import { Box, chakra } from '@chakra-ui/react';
import * as React from 'react';
import { Icon } from '../shared/Icon';

interface INavLink {
  value: string;
  icon: string;
  label: string;
}

interface IProps {
  links: INavLink[];
  onSelect: (value: string) => void;
}

export const NavLinks = (props: IProps): React.ReactElement => {
  return (
    <Box
      as='nav'
      display='flex'
      bg='menuBackground'
      borderRadius='6px'
      aria-label='Quick Actions'
    >
      {props.links.map(
        (link, i): React.ReactElement => (
          <chakra.a
            key={link.value}
            href={`#${link.value}`}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>): void => {
              e.preventDefault();
              props.onSelect(link.value);
            }}
            display='flex'
            alignItems='center'
            justifyContent='center'
            gap='4px'
            color='buttonText'
            whiteSpace='nowrap'
            cursor='pointer'
            padding='6px 10px'
            position='relative'
            fontSize='xs'
            textDecoration='none'
            css={{
              ...(i > 0 && {
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '1px',
                  height: '60%',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                },
              }),
              '&:hover i': {
                color: 'warningAccent',
              },
            }}
          >
            <Icon name={link.icon} size='small' />
            {link.label}
          </chakra.a>
        )
      )}
    </Box>
  );
};
